import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class NonNullExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.NonNullExpression;
    }
    visitNode(sb, expr, options) {
        sb.visit(tsUtils.expression.getExpression(expr), options);
    }
}

//# sourceMappingURL=NonNullExpressionCompiler.js.map
